export const STORE_REGION_FAILED = 'store_region_failed';
export const STORE_REGION_PENDING = 'store_region_pending';
export const STORE_REGION_LOADED = 'store_region_loaded';
